import script from "./MyBetsSlips.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBetsSlips.vue?vue&type=script&setup=true&lang=js"

import "./MyBetsSlips.vue?vue&type=style&index=0&id=47522d80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47522d80"]])

export default __exports__